interface DefaultArrowSelectProps {
  className?: string;
  color?: string;
}

const ArrowCrumb = ({ color, className }: DefaultArrowSelectProps) => {
  return (
    <>
      <svg width="16" height="17" viewBox="0 0 16 17" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path d="M12.7689 8.78467L5.15803 15.9199C4.95657 16.1088 4.94637 16.4252 5.13523 16.6266C5.3241 16.8281 5.64052 16.8383 5.84197 16.6494L13.842 9.14944C14.0527 8.9519 14.0527 8.61744 13.842 8.4199L5.84197 0.919901C5.64052 0.731036 5.3241 0.741243 5.13523 0.942699C4.94637 1.14416 4.95657 1.46057 5.15803 1.64944L12.7689 8.78467Z" className={className}/>
      </svg>
    </>
  );
}

export default ArrowCrumb;